import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import {
  faArrowRight,
  faHourglassHalf
} from '@fortawesome/pro-light-svg-icons';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { PreparationModel } from 'projects/runner/src/app/models/preparation.model';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';

@Component({
  selector: 'app-preparation-container',
  templateUrl: './preparation-container.component.html',
  styleUrls: ['./preparation-container.component.scss']
})
export class PreparationContainerComponent implements OnInit, OnChanges {

  @Input() ac: AcModel = null;

  public faArrowRight = faArrowRight;
  public faHourglassHalf = faHourglassHalf;
  public isOpen = false;

  constructor(
    private router: Router,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ac) {
      this.isOpen = this.ac?.status === 'planned';
    }
  }

  public toggleContainer(): void {
    this.isOpen = !this.isOpen;
  }

  public openPreparation(preparation: PreparationModel): void {
    if (preparation.visible === true || this.auth.isModerator()) {
      this.router.navigate(['/ac/preparation', preparation.id]);
    }
  }

}
